import { render } from "./SimpleTime.vue?vue&type=template&id=1da2846a&scoped=true&ts=true"
import script from "./SimpleTime.vue?vue&type=script&lang=ts"
export * from "./SimpleTime.vue?vue&type=script&lang=ts"

import "./SimpleTime.vue?vue&type=style&index=0&id=1da2846a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da2846a"]])

export default __exports__